import { collection, getFirestore } from 'firebase/firestore'
import { getRecordsCollectionName } from './getRecordsCollectionName'

export const getRecordsCollection = () => {
  const db = getFirestore()

  return collection(db, getRecordsCollectionName())
}
